module.exports = __webpack_public_path__ + "img/metaldesplegado.be15feaa.jpg";